"use client";

import React from "react";
import MyCard from "../MyCard";
import ScreenerTable, { type ScreenerData } from "./ScreenerTable";
import { Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";

// Sample data - replace with real data later
const buySetupData: ScreenerData[] = [
  { symbol: "BTC", price: 84159.6, priceChange: 1.21, signal: "Overbought" },
  { symbol: "ETH", price: 9.35, priceChange: -3.21, signal: "New" },
  { symbol: "LTC", price: 9.35, priceChange: -3.21, signal: "Unusual Volume" },
  { symbol: "DASH", price: 9.35, priceChange: -3.21, signal: "Unusual Volume" },
  { symbol: "DOGE", price: 0.02345, priceChange: -3.21, signal: "Unusual Volume" },
  { symbol: "ELD", price: 59.6, priceChange: 1.21, signal: "Top Gainers" },
  { symbol: "USDT", price: 59.6, priceChange: 1.21, signal: "Unusual Volume" },
  { symbol: "BNB", price: 59.6, priceChange: 1.21, signal: "Unusual Volume" },
  { symbol: "SOL", price: 59.6, priceChange: 1.21, signal: "Unusual Volume" },
  { symbol: "XRP", price: 59.6, priceChange: 1.21, signal: "Unusual Volume" },
];

const sellSetupData: ScreenerData[] = [
  { symbol: "BTC", price: 84159.6, priceChange: 1.21, signal: "Oversold" },
  { symbol: "ETH", price: 9.35, priceChange: -3.21, signal: "New Low" },
  { symbol: "LTC", price: 9.35, priceChange: -3.21, signal: "Most Volatile" },
  { symbol: "DASH", price: 9.35, priceChange: -3.21, signal: "New Low" },
  { symbol: "DOGE", price: 0.02345, priceChange: -3.21, signal: "New Low" },
  { symbol: "ELD", price: 59.6, priceChange: 1.21, signal: "Top Losers" },
  { symbol: "USDT", price: 59.6, priceChange: 1.21, signal: "Top Losers" },
  { symbol: "BNB", price: 59.6, priceChange: 1.21, signal: "Top Losers" },
  { symbol: "SOL", price: 59.6, priceChange: 1.21, signal: "Top Losers" },
  { symbol: "XRP", price: 59.6, priceChange: 1.21, signal: "Top Losers" },
];

const patternData: ScreenerData[] = [
  { symbol: "BTC", price: 84159.6, priceChange: 1.21, signal: "Overbought" },
  { symbol: "ETH", price: 9.35, priceChange: -3.21, signal: "New high" },
  { symbol: "LTC", price: 9.35, priceChange: -3.21, signal: "Unusual Volume" },
  { symbol: "DASH", price: 9.35, priceChange: -3.21, signal: "Unusual Volume" },
  { symbol: "DOGE", price: 0.02345, priceChange: -3.21, signal: "Unusual Volume" },
  { symbol: "ELD", price: 59.6, priceChange: 1.21, signal: "Top Gainers" },
  { symbol: "USDT", price: 59.6, priceChange: 1.21, signal: "Unusual Volume" },
  { symbol: "BNB", price: 59.6, priceChange: 1.21, signal: "Unusual Volume" },
  { symbol: "SOL", price: 59.6, priceChange: 1.21, signal: "Unusual Volume" },
  { symbol: "XRP", price: 59.6, priceChange: 1.21, signal: "Unusual Volume" },
];

const KlardaScreener: React.FC = () => {
  return (
    <MyCard
      className="w-full"
      title="KLARDA SCREENERS"
      extra={
        <Button type="link" className="flex items-center gap-1">
          More Screeners <ArrowRightOutlined />
        </Button>
      }
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
        <ScreenerTable data={buySetupData} title="Buy set-up" tag={{ text: "Hot", type: "hot" }} />
        <ScreenerTable data={sellSetupData} title="Sell set-up" tag={{ text: "Hot", type: "hot" }} />
        <ScreenerTable data={patternData} title="Pattern" tag={{ text: "Trending", type: "trending" }} />
      </div>
    </MyCard>
  );
};

export default KlardaScreener;

